module.exports = "<figure><img *ngIf=\"src\" [src]=\"src\"></figure>";